import { render, staticRenderFns } from "./TdAdditionalBankAccount.vue?vue&type=template&id=99bfb450&"
import script from "./TdAdditionalBankAccount.vue?vue&type=script&lang=ts&"
export * from "./TdAdditionalBankAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports